var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-form",
    {
      class: _vm.$style.dialog,
      on: { cancel: _vm.$formCancelHandler, submit: _vm.$formSubmitHandler },
    },
    [
      _c("span", { attrs: { slot: "header" }, slot: "header" }, [
        _vm._v("Change Job Title"),
      ]),
      _c(
        "div",
        {
          staticClass: "vModalDefaultBody",
          attrs: { slot: "body" },
          slot: "body",
        },
        [
          _c(
            "rb-input",
            {
              attrs: {
                "for-id": "jobTitle",
                error: _vm.$showError("jobTitle"),
              },
            },
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v("Job Title"),
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.data.jobTitle,
                    expression: "data.jobTitle",
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: { required: true, max: 100 },
                    expression: "{required: true, max: 100}",
                  },
                ],
                staticClass: "rbInput",
                attrs: {
                  id: "jobTitle",
                  type: "text",
                  name: "jobTitle",
                  "data-vv-as": "jobTitle",
                },
                domProps: { value: _vm.data.jobTitle },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.data, "jobTitle", $event.target.value)
                  },
                },
              }),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }